module.exports = __webpack_public_path__ + "static/media/better-remente.4bfa149e.svg";